import { CatalogProvider } from "./Catalog.context";
import CatalogContainer from "./CatalogContainer";
import CatalogScaler from "./CatalogScaler";
import CatalogPageRouter from "./CatalogPageRouter";
import GlobalNavigation from "components/GlobalNavigation";
import ScrollTop from "./ScrollTop";
import SianNav from "components/SianNav";

export default function Catalog() {
  return (
    <CatalogProvider>
      <ScrollTop />
      <CatalogContainer>
        <CatalogScaler>
          <CatalogPageRouter />
          <GlobalNavigation />
        </CatalogScaler>
      </CatalogContainer>
      {process.env.REACT_APP_IS_SIAN === "true" && <SianNav />}
    </CatalogProvider>
  );
}
